import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ThankYouPage() {

    const navigate=useNavigate()
    const hndleClick=()=>{
navigate('/')
    }
  return (
    <>
      <Grid
        container
      
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Grid item >
         
          <img src="/logo-siec.webp"  height={80}/>
         
        </Grid>
        <Grid item mt={3}>
            <Typography sx={{fontSize:'70px', color:'black'}}>Thank You!</Typography>
          
        </Grid>
        <Grid item >
        <Typography sx={{ color:'black',fontSize:'20px'}}>For registering with us👍.</Typography>
        </Grid>

        <Grid item >
        <Typography sx={{ color:'black',fontSize:'20px'}}>Your Enquiry is being processed.</Typography>
        </Grid>

       

<Grid item mt={4}>
<Button variant="contained"  style={{background:'#E3153B',fontSize:'15px', fontWeight:600, borderRadius:'25px'}} onClick={hndleClick}>Proceed to Student portal</Button>
</Grid>
       
      </Grid> 
    </>
  );
}
